const _memberBenefit = {
  type: 'object',
  properties: {
    benefittype: {
      type: 'string',
      title: 'Etutyyppi',
      anyOf: [
        // {
        //   type: 'string',
        //   title: 'Aikaisempi varausoikeus',
        //   enum: ['earlybird'],
        // },
        // {
        //   type: 'string',
        //   title: 'Live varaustilanne seuranta',
        //   enum: ['stalkerservice'],
        // },
        {
          type: 'string',
          title: 'Jäsenalennus',
          enum: ['discount'],
        },
        {
          type: 'string',
          title: 'Aktiviteettien vapaa käyttö',
          enum: ['activityentries']
        },
        {
          type: 'string',
          title: 'Aktiviteettialennus',
          enum: ['activitydiscount'],
        }
      ],
    },
  },
  dependencies: {
    benefittype: {
      oneOf: [
        {
          properties: {
            benefittype: {
              enum: ['earlybird'],
            },
            earlier: {
              type: 'number',
              title: 'Montako päivää normaalia aiemmin',
            },
            resources: {
              type: 'array',
              title: 'Mitkä kentät',
              items: {
                oneOf: [
                  { const: '1', title: 'Kenttä 1' },
                  { const: '2', title: 'Kenttä 2' },
                  { const: '3', title: 'Kenttä 3' },
                ],
              },
              uniqueItems: true,
            },
          },
        },
        {
          properties: {
            benefittype: {
              enum: ['stalkerservice'],
            },
          },
        },
        {
          properties: {
            benefittype: {
              enum: ['discount'],
            },
            pricing: {
              title: 'Hinnoittelu',
              type: 'string',
              oneOf: [],
            },
            maxperday: { type: 'number', title: 'Käyttökertojen maksimimäärä päivässä', default: 0 },
            maxperweek: { type: 'number', title: 'Käyttökertojen maksimimäärä viikossa', default: 0 },
            maxpermonth: { type: 'number', title: 'Käyttökertojen maksimimäärä kuukaudessa', default: 0 },
            maxperyear: { type: 'number', title: 'Käyttökertojen maksimimäärä vuodessa', default: 0 },
          },
        },
        {
          properties: {
            benefittype: {
              enum: ['activityentries'],
            },
            entrycount: {
              title: 'Montako kertaa',
              type: 'number'
            },
            entrywindow: {
              title: 'Missä aikaikkunassa kerrat on käytettävissä',
              type: 'string',
              oneOf: [
                { const: 'day', title: 'Päivässä' },
                { const: 'week', title: 'Viikossa' },
                { const: 'month', title: 'Kuukaudessa' },
                { const: 'year', title: 'Vuodessa' },

              ]
            },
            // Rajaukset. Molemmat sisältävät KEY-arvoja, eivät nimiä - activity.sport ja
            // activity.type sisältävät nimen, joten kerrat kuluttava taustapalvelu kääntää
            // nimen keyksi config/sports- ja config/activitytypes-listojen kautta.
            // Tyhjä lista = ei rajausta.
            sports: {
              title: 'Lajit (tyhjä = kaikki lajit)',
              type: 'array',
              items: {
                type: 'string',
                // Täytetään ajossa MembershipsContainerissa.
                oneOf: [],
              },
              uniqueItems: true,
            },
            activitytypes: {
              title: 'Aktiviteettityypit (tyhjä = kaikki tyypit)',
              type: 'array',
              items: {
                type: 'string',
                oneOf: [],
              },
              uniqueItems: true,
            }
          }

        },
        // Prosenttialennus aktiviteeteista, valinnaisesti vain tietyistä lajeista.
        //
        // Erillinen 'discount'-edusta: se osoittaa kokonaiseen resourcepricings-hinnastoon
        // ja koskee kenttävuoroja, tämä on prosentti aktiviteetin hinnasta.
        //
        // sports[] sisältää lajien KEY-arvot, ei nimiä. Key on pysyvä, nimi on
        // uudelleennimettävissä - ja activity.sport sisältää nimen, joten alennuksen
        // ratkaiseva taustapalvelu joutuu kääntämään nimen keyksi config/sports-listan
        // kautta. Tyhjä lista = kaikki lajit.
        {
          properties: {
            benefittype: {
              enum: ['activitydiscount'],
            },
            discountpercent: {
              title: 'Alennusprosentti aktiviteeteista',
              type: 'number',
            },
            sports: {
              title: 'Lajit (tyhjä = kaikki lajit)',
              type: 'array',
              items: {
                type: 'string',
                // Täytetään ajossa MembershipsContainerissa: DEFAULT_SPORTS + config/sports.
                oneOf: [],
              },
              uniqueItems: true,
            },
          },
        }
      ],
    },
  },
}

export const _membershipClass = {
  name: { type: 'string', title: 'Jäsenyyden nimi, esim. Tennisseuran hallisarjapelaaja' },
  displayName: { type: 'string', title: 'Asiakkaille näkyvä nimi' },
  description: { type: 'string', title: 'Kuvaus' },
  benefits: {
    title: '',
    description: 'Edut',
    type: 'array',
    items: _memberBenefit,
  },
  availableinshop: {
    type: 'string',
    title: 'Näytetäänkö verkkokaupassa',
    oneOf: [
      { const: 'true', title: 'Kyllä' },
      { const: 'false', title: 'Ei' },
    ],
  },
  // verifymethod: {
  //   type: 'string',
  //   title: 'Hankintatapa',
  //   enum: ['purchase'],
  //   enumNames: ['Tarkistetaan käsin', 'Ostettava'],
  // },
  provideritem: {
    type: 'boolean',
    title: 'Kumppanituote',
    // enum: ['true', 'false'],
    // enumNames: ['Kyllä', 'Ei'],
  },
  quota: {
    type: 'number',
    title: 'Yhtäaikaisvarauksien määrä',
    default: 0,
  },
  maxduration: {
    type: 'number',
    title: 'Varauksen maksimikesto (minuutteina)',
    default: 0,
  },
}

export const _membershipClassDeps = {
  availableinshop: {
    oneOf: [
      {
        properties: {
          availableinshop: {
            enum: ['true'],
          },
          vat: {
            type: 'number', title: 'ALV',
            oneOf: [
              { const: 0, title: '0%' },
              { const: 10, title: '10%' },
              { const: 13.5, title: '13,5%' },
              { const: 14, title: '14%' },
              { const: 24, title: '24%' },
              { const: 25.5, title: '25,5%' },
            ]
          },
          image: { type: 'string', title: 'Verkkokaupan tuotekuva', items: { type: 'object', images: [] }, minaspectratio: 1 },
          variations: {
            title: '',
            description: 'Hintavaihtoehdot',
            type: 'array',
            items: {
              type: 'object',
              properties: {
                name: { type: 'string', title: 'Nimi' },
                price: { type: 'number', title: 'Hinta' },
                productCode: { type: 'string', title: 'Tuotekoodi' },
              },
            },
          },
          confirmationSubject: { type: 'string', title: 'Vahvistusviestin otsikko' },
          confirmationMessage: { type: 'string', title: 'Vahvistusviestin sisältö' },
          accounting: { type: 'string', title: 'Kirjanpidontili' },
          validity: {
            type: 'string',
            title: 'Voimassaoloaika',
            oneOf: [
              { const: 'rolling', title: 'Rullaava ajanjakso' },
              { const: 'next', title: 'Seuraavaan ajanjaksoon' },
              { const: 'fixed', title: 'Kiinteä ajanjakso' },
              { const: 'permanent', title: 'Pysyvä' },
            ],
          },
          // Jatkuva laskutus. Ei omaa jaksokenttää: Voimassaoloajan 'Rullaava ajanjakso'
          // (unit + amount) ON laskutusjakso ja jakson hinta tulee hintavaihtoehdoista,
          // joten erillinen chargeperiod vain kaksintaisi tiedon ja voisi olla ristiriidassa.
          //
          // Kenttä elää tässä availableinshop === 'true' -haarassa, koska kortin
          // tallettaminen on verkkokaupan tapahtuma. Huomaa että set({merge:true}) jättää
          // arvon dokumenttiin vaikka jäsenyys otettaisiin myöhemmin pois kaupasta - lue
          // aina isContinuous()-apurin kautta.
          continuous: {
            type: 'boolean',
            title: 'Jatkuva laskutus',
            description:
              'Asiakas tallettaa maksukortin ja seuraava jakso veloitetaan automaattisesti. ' +
              'Laskutusjaksona käytetään Voimassaoloajan rullaavaa ajanjaksoa ja jakson hintana ' +
              'hintavaihtoehtoa.',
          },
          // validityperiod: {
          //   type: 'number',
          //   title: 'Voimassaoloaika päivinä ostohetkestä (0 = ei päättymistä)',
          // },
          // validfrom: {
          //   type: 'string',
          //   title: 'Voimassaolo alkaa, jätä tyhjäksi jos alkaa ostohetkestä',
          //   format: 'date',
          // },
          // validuntil: {
          //   type: 'string',
          //   title: 'Voimassaolo päättyy, jos voimassa oloaika on asetettu se kumpi on aiemmin määrää',
          //   format: 'date',
          // },
        }
      },
      {
        properties: {
          availableinshop: {
            enum: ['false'],
          },
        }
      }
    ]
  },
  verifymethod: {
    oneOf: [
      {
        properties: {
          verifymethod: {
            enum: ['manual'],
          },
        },
      },
      {
        properties: {
          verifymethod: {
            enum: ['integration'],
          },
          verifyservice: {
            type: 'string',
            title: 'Tarkistuspalvelu',
            oneOf: [
              { const: 'tennisclub', title: 'Tennisclub' },
              { const: 'openid', title: 'OpenId' },
            ],
          },
        },
        // required: ['verifyservice']
      },
      {
        properties: {
          verifymethod: {
            enum: ['purchase'],
          },
          // pricing: {
          //   type: 'number',
          //   title: 'Hinta',
          // },
          validityperiod: {
            type: 'number',
            title: 'Voimassaoloaika päivinä (0 = ei päättymistä)',
          },
        },
        // required: ['verifyservice']
      },
    ],
  },
  provideritem: {
    oneOf: [
      {
        properties: {
          provideritem: {
            enum: [true],
          },
          provider: {
            type: 'string',
            title: 'Kumppani',
            oneOf: [],
          },
        },
        required: ['provider'],
      },
      {
        properties: {
          provideritem: {
            enum: [false],
          },
        },
      },
    ],
  },
  validity: {
    oneOf: [
      {
        properties: {
          validity: {
            enum: ['rolling'],
          },
          unit: {
            type: 'string',
            title: 'Rullaava ajanjakso',
            oneOf: [
              { const: 'day', title: 'Päivä' },
              { const: 'week', title: 'Viikko' },
              { const: 'month', title: 'Kuukausi' },
              { const: 'year', title: 'Vuosi' },
            ],
          },
          amount: {
            type: 'number',
            title: 'Montako ajanjaksoa ostohetkestä',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['next'],
          },
          endof: {
            type: 'string',
            title: 'Päättyy',
            oneOf: [
              { const: 'month', title: 'Kuukauden lopussa' },
              { const: 'year', title: 'Vuoden lopussa' },
            ],
          },
          daysahead: {
            type: 'number',
            title: 'Montako päivää ennen aletaan myydä seuraavaa ajanjaksoa. 0 = tästä hetkestä kuluvan ajanjakson loppuun asti.',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['fixed'],
          },
          firstvalid: {
            type: 'string',
            title: 'Ensimmäinen voimassaolopäivä',
            format: 'date',
          },
          lastvalid: {
            type: 'string',
            title: 'Viimeinen voimassaolopäivä',
            format: 'date',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['permanent'],
          },
          firstvalid: {
            type: 'string',
            title: 'Ensimmäinen voimassaolopäivä',
            format: 'date',
          },
        },
      },
    ],
  },
}

export const _membershipUISchema = {
  description: {
    'ui:widget': 'editorWidget',
  },
  confirmationMessage: {
    'ui:widget': 'editorWidget',
  },
  image: {
    'ui:widget': 'imageWidget',
  },
  vat: {
    'ui:enumDisabled': [10, 14, 24],
  },

}
